module.exports = __webpack_public_path__ + "static/wt-logo-ba9c7ebc5c65694e4e2729c092106e10.svg";